import { ReferralsEnvironment } from './interface';

export const environment: ReferralsEnvironment = {
  analytics: true,
  analyticsKey: 'DlaokckWxNBiyBoQUTZJGRRF4MeRanyf',
  production: true,
  hmr: false,
  protocol: 'https',
  domain: 'api.s.recruitee.com',
  authUrl: 'https://auth.s.recruitee.com',
  apiUrl: 'https://api.s.recruitee.com',
  appUrl: 'https://s.recruitee.com',
  webAppUrl: 'https://app.s.recruitee.com',
  landingPageUrl: 'https://s.recruitee.com/',
  recaptchaSiteKey: '6LdznlAUAAAAAGaYOdwE_id-rzKrOvsc-a-LHRGl',
  websocketUrl: 'wss://api.s.recruitee.com/referral_portal_socket',
  phraseAppProjectId: '33b93fa8c87183f3257609a570160087',
  resolveSubdomainFromHost: false,
  sentry_dsn: 'https://b8fc57fcde3e4d61b6d704b761bd9125@o18167.ingest.sentry.io/1440981',
};
